import { z } from 'zod/v4';
import { Brand } from '../branded-types';

export type PaymentProviderId = Brand<string, 'paymentProviderId'>;

export const PAYMENT_PROVIDER_SCHEMA: z.ZodType<IPaymentProvider> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as PaymentProviderId)
    .optional(),
  filename: z.string(),
  fileExtension: z.string(),
});

export const PAYMENT_PROVIDERS_SCHEMA: z.ZodType<IPaymentProvider[]> = z.array(
  PAYMENT_PROVIDER_SCHEMA
);

export interface IPaymentProvider {
  id?: PaymentProviderId;
  filename: string;
  fileExtension: string;
}

export const DEFAULT_PAYMENT_PROVIDERS: IPaymentProvider[] = [
  {
    id: 'b0e01472-7df0-4cb6-bb7c-2b62d26f634b' as PaymentProviderId,
    filename: 'LOGPAY',
    fileExtension: 'svg',
  },
  {
    id: 'c3f68420-5c64-4e78-9e56-11f8072049e2' as PaymentProviderId,
    filename: 'Mastercard',
    fileExtension: 'svg',
  },
  {
    id: 'd7a96e28-1b42-49cf-8927-14ec13c7bb90' as PaymentProviderId,
    filename: 'VISA',
    fileExtension: 'svg',
  },
  {
    id: 'e1c953a4-9213-48e0-94e8-89c0919241b7' as PaymentProviderId,
    filename: 'PayPal',
    fileExtension: 'svg',
  },
  {
    id: '52a84508-f6d0-4929-a61a-7085f4e895ae' as PaymentProviderId,
    filename: 'Apple Pay',
    fileExtension: 'svg',
  },
  {
    id: '5a35e44b-9efb-49ec-930f-75cc554e2c0e' as PaymentProviderId,
    filename: 'Google Pay',
    fileExtension: 'svg',
  },
  {
    id: '16f83eaa-deb9-4c34-ab7c-e3d35fdd1c3b' as PaymentProviderId,
    filename: 'PAYONE',
    fileExtension: 'svg',
  },
  {
    id: 'a8e586b1-f9d4-4d0d-aa99-f11a8c2baed0' as PaymentProviderId,
    filename: 'CrefoPay',
    fileExtension: 'svg',
  },
];
